// extracted by mini-css-extract-plugin
module.exports = {"root":"Object_root__pDJlM","page":"Object_page__22med","more":"Object_more__NrEod"};